// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__14U_3","gfeWrapper":"CalendarEvent_gfeWrapper__3JaRK"};